import Button from 'components/Button';

export const contentBlocks = {
  Button,
};